import React from "react";

function ScrollToBottom({ visible, onClick }) {
  if (!visible) return null;

  return (
    <button
      className="scroll-to-bottom-btn"
      onClick={onClick}
      title="Scroll to bottom"
    >
      <span className="arrow-icon">↓</span>
    </button>
  );
}

export default ScrollToBottom;